import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Functional route guard — redirects to Keycloak login if not authenticated.
 * Waits for auth initialization before checking.
 */
export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);

  // Wait for auth to initialize (OIDC discovery + session check)
  if (!auth.initialized()) {
    await auth.init();
  }

  if (auth.isAuthenticated()) {
    return true;
  }

  auth.login();
  return false;
};
